import {attempt, noop, createSelector, createStructuredSelector} from 'helpers';
import {pluralType} from './type';
import {inProgress} from './activities';
import {createRestrictedSelector} from 'store/permissions/limits.selector';

const restricted = createStructuredSelector({
  activities: createRestrictedSelector(inProgress.activities, 'activities'),
  recurring: createRestrictedSelector(inProgress.recurring, 'recurring'),
});

export const isRestricted = createSelector(
  [ restricted ],
  ( restricted ) => activity => attempt(restricted[type(activity)] || noop, activity)
);

function type(activity) {
  return pluralType(activity).replace(/routines|habits/, 'recurring');
}
